module.exports = " <label class=switch :class=\"{ [`is-${type}`]: type, [`is-${size}`]: size, checked: value }\"> <input type=checkbox :disabled=disabled v-model=value> </label> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-switch/src/Switch.vue
// module id = 932
// module chunks = 2